<template>
    <div class="rating-table">
        <div class="rating-table-heading">
          <div class="heading-area"><span>Area</span></div>
          <div class="heading-cutoff"><span>Cutoff</span></div>
          <div class="heading-total-score"><span>Total Score</span></div>
          <div class="heading-rating" style="display:flex;flex-basis: 1020px;">
            <div class="heading"><span>0</span></div>
            <div class="heading"><span>5</span></div>
            <div class="heading"><span>10</span></div>
            <div class="heading"><span>15</span></div>
            <div class="heading"><span>20</span></div>
            <div class="heading"><span>25</span></div>
            <div class="heading"><span>30</span></div>
            <div class="heading"><span>35</span></div>
            <div class="heading"><span>40</span></div>
            <div class="heading"><span>45</span></div>
            <div class="heading"><span>50</span></div>
            <div class="heading"><span>55</span></div>
            <div class="heading"><span>60</span></div>
          </div>
        </div>
        <div class="rating-table-content" v-for="(question, key) in question.question" :key="key">
          <div class="content-area"><span>{{ question.area }}</span></div>
          <div class="content-cutoff"><span>{{ question.cutoff1}}</span></div>
          <div class="content-total-score"><span>{{ hasAnswer(question.area) }}</span></div>
            <div class="content-rating" :style="getStyle(question.cutoff1,question.cutoff2)">

              <div  class="rating" v-for="(value, key) in question.values" :key="key">
                  <div :class="['circle',getColorName(value.rating,question.cutoff1,question.cutoff2), {'active': isActive(question.area,value.rating)}]" @click="updateAnswer(question.area,value.rating,$event)"></div>
                </div>
            </div>
  
        </div>
        <div class="rating-table-info">
          <div class="heading-area"><span></span></div>
          <div class="heading-cutoff"><span></span></div>
          <div class="heading-total-score"><span></span></div>
          <div class="infos">
            <div class="info"><div class="info-icon red"></div><span>Further assessment with a professional may be needed</span></div>
            <div class="info"><div class="info-icon yellow"></div><span>Provide learning activities and monitor</span></div>
            <div class="info"><div class="info-icon green"></div><span>Child’s development appears to be on schedule</span></div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'RatingTable',
  props: {
    question: {
      type: Object,
      required: true,
    },
    answer: {
      type: [Object,String],
      required: false,
    },
  },
  data() {
    return {
      updatedAnswer: {},
    }
  },
  watch: {
    answer(newAnswer, oldAnswer) {
      if(typeof newAnswer === 'string')
      {
        this.updatedAnswer = JSON.parse(newAnswer);
      }
    }
  },
  methods: {
    hasAnswer(key) {
      if(!this.updatedAnswer[key]){
        return 0;
      }
      else{
        return  this.updatedAnswer[key];
      }
    },
    updateAnswer(area,rating,event) {
      event.target.closest('.rating-table-content').getElementsByClassName('content-total-score')[0].getElementsByTagName('span')[0].textContent=rating;
       let temp = area;
      if(this.updatedAnswer)
      {
          if(this.updatedAnswer.hasOwnProperty(temp)){
              this.updatedAnswer[temp] = rating;
          }
          else{
              const newObj = { ...this.updatedAnswer}
              newObj[temp] = rating;
              this.updatedAnswer = newObj
          }
      }
      else{
          const obj = {};
          obj[temp] = rating;
          this.updatedAnswer = obj;
      }
      
      if(JSON.parse(JSON.stringify(this.question.question)).length === Object.keys(this.updatedAnswer).length)
      this.$emit('input', this.updatedAnswer);
    },
    isActive(area,rating) {
      let temp = area;
      if(this.updatedAnswer && this.updatedAnswer.hasOwnProperty(temp))
      {
        let value = this.updatedAnswer[temp];
        if(value == rating)
            return true
        else 
            return false
      }
      else{
        return false;
      }
    },
    getColorName(rating,cutoff1,cutoff2){
      //console.log('rating : '+rating+' cutoff1 : '+cutoff1+' cutoff2 : '+cutoff2);
      if(rating >= cutoff2)
        return 'green';
      else if (rating < cutoff2 && rating > cutoff1)
        return 'yellow';
      else if (rating <= cutoff1)
        return 'red';
    },
    getStyle(cutoff1,cutoff2) {
      let halfOfColumnWidth = (1020/13)/2;
      let columnWidth = (1020/13);
      let start = (halfOfColumnWidth*100)/1020;
      let one = ((columnWidth*100)/1020)/5;
      let half = (((columnWidth*100)/1020)/5)/2;

      let beforeCutoff1 =0; let beforeCutoff2 =0; let afterCutoff1 = 0; let afterCutoff2 = 0;
      if(cutoff1 % 5 == 0)
        beforeCutoff1 = cutoff1;
      else
      {
        afterCutoff1 =  Math.ceil(cutoff1 / 5) * 5;
        beforeCutoff1 =  afterCutoff1 - 5;
      }
    
      if(cutoff2 % 5 == 0)
        beforeCutoff2 = cutoff2;
      else
      {
        afterCutoff2 =  Math.ceil(cutoff2 / 5) * 5;
        beforeCutoff2 =  afterCutoff2 - 5;
      }
      
      let count1 = -1; let count2 = -1;
      for(let i=0; i<=beforeCutoff1; i += 5){
        count1 = count1 + 1;
      }

      for(let i=0; i<=beforeCutoff2; i += 5){
        count2 = count2 + 1;
      }

      let diff1 = cutoff1 - beforeCutoff1;
      let diff2 = cutoff2 - beforeCutoff2;
    
      let diff1_add; let diff2_add;
      if (!Number.isInteger(diff1)) {
        const diff1_left = diff1.toString().split('.')[0];
        const diff1_right = diff1.toString().split('.')[1];
        if(diff1_right>=5)
        diff1_add = (diff1_left * one) + half;
        else
        diff1_add = (diff1_left * one);
      }
      else{
        diff1_add = diff1 * one;
      }

      if (!Number.isInteger(diff2)) {
        const diff2_left = diff2.toString().split('.')[0];
        const diff2_right = diff2.toString().split('.')[1];
        if(diff2_right>=5)
        diff2_add = (diff2_left * one) + half;
        else
        diff2_add = (diff2_left * one);
      }
      else{
        diff2_add = diff2 * one;
      }
      let cutoff1Percentage = (count1*columnWidth*100)/1020 + start + diff1_add;
      let cutoff2Percentage = (count2*columnWidth*100)/1020 + start + diff2_add;

      return {
        display: 'flex',
        flexBasis: '1020px',
        background: `linear-gradient(to right, #F6D7D8 0%, #F6D7D8 ${cutoff1Percentage}%, #FDF2D5 ${cutoff1Percentage}%, #FDF2D5 ${cutoff2Percentage}%, #E2F1E2 ${cutoff2Percentage}%, #E2F1E2 1020%)`
      };  
    }
  },
  mounted() {
    if(typeof this.answer === 'string') {
      this.updatedAnswer = JSON.parse(this.answer);
    }
  }
};
</script>

<style lang="scss" scoped>
.rating-table{
  .rating-table-heading{
    display: flex;
    padding-bottom: 10px;
    .heading-area{
        flex-basis: 200px;
        margin-right: 20px;
        text-align: right;
        position: relative;
        span{
            font-weight: 500;
            position: absolute;
            right: 0;
            bottom: 0;
        }
    }
    .heading-cutoff{
        flex-basis: 100px;
        text-align: center;
        margin-right: 12px;
        position: relative;
        span{
            font-weight: 500;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }
    .heading-total-score{
        flex-basis: 100px;
        span{
            font-weight: 500;
        }
    }
    .heading-rating{
      .heading{
        position: relative;
        text-align: center;
        flex: 1 1 0;
        width: 0;
        span{
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: 0 auto;
        }
      }
    }
  }
  .rating-table-content{
    display: flex;
    border-top: 1px solid #e4f4f9;
    .content-area{
        text-align: right;
        flex-basis: 200px;
        margin-right: 20px;
    }
    .content-cutoff{
        flex-basis: 100px;
        text-align: center;
        margin-right: 12px;
    }
    .content-total-score{
        flex-basis: 100px;
        span{
            font-weight: 500;
        }
    }
    .content-rating{
      height: 40px;
      .rating{
        flex: 1 1 0;width: 0;
        display: flex;
        justify-content: center;
          align-items: center;
        .circle{
          width: 25px;
          height: 25px;
          background: white;
          border-radius: 100%;
          &.active{
            &.red{
              background:#D4494E;
            }
            &.yellow{
              background:#F6C540;
            }
            &.green{
              background:#7ABE7B;
            }
            
          }
        }
      }
    }
  }
  .rating-table-info{
    display: flex;
    padding-bottom: 10px;
    margin-top: 15px;
    .heading-area{
        flex-basis: 200px;
        margin-right: 20px;
        text-align: right;
        span{
            font-weight: 500;
        }
    }
    .heading-cutoff{
        flex-basis: 100px;
        text-align: center;
        margin-right: 12px;
        span{
            font-weight: 500;
        }
    }
    .heading-total-score{
        flex-basis: 100px;
        span{
            font-weight: 500;
        }
    }
    .infos{
      display:flex;
      width: 100%;
      .info{
        text-align: left;
        flex: 1 1 0;
        width: 0;
        display:flex;
        .info-icon{
          width: 20px;
          height: 20px;
          border-radius: 100%;
          min-width: 20px;
          min-height: 20px;
          align-self: center;
          &.red{
            background: #D4494E;
          }
          &.yellow{
            background: #F6C540;
          }
          &.green{
            background: #7ABE7B;
          }
        }
        span{
          font-size: 11px;
          align-self: center;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>